<template>
  <!--
      作者：kmdshop
      时间：2019-10-24
      描述：sku管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.category_id" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称"><el-input size="small" v-model="searchForm.product_name" placeholder="请输入商品名称"></el-input></el-form-item>
        <el-form-item label="编码"><el-input size="small" v-model="searchForm.product_no" :placeholder="product_no_search"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column type="selection"  width="45"></el-table-column>
          <el-table-column type="product_sku_id" prop="product_sku_id"  ></el-table-column>
          <el-table-column prop="product_name" label="产品" width="200px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image?scope.row.image:''" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">￥{{ scope.row.product_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="spec_value" label="规格"></el-table-column>
          <el-table-column prop="product_no" label="商品编号"></el-table-column>
          <el-table-column prop="product_price" label="价格"></el-table-column>
          <el-table-column prop="is_open_wholesale" label="开启批发价">
              <template slot-scope="scope">
                 <el-switch
                  @change="setOpenWholesale(scope.row)"
                  v-model="scope.row.is_open_wholesale"
                  active-color="#13ce66"
                  inactive-color="#ff4949" style="width:50px">
                </el-switch>
                 
              </template>
          </el-table-column>
          <el-table-column prop="is_open_wholesale" label="批发价" width="400px">
              <template slot-scope="scope">
                <div class="d-s-c ww100 border-b-d">
                    <el-button @click="setWholesale(scope.row)" type="text" size="small" >设置批发价</el-button>
                </div>
                <div class="d-s-c ww100 border-b-d" v-for="(item,index) in scope.row.wholesale_price" :key="index">
                    <p class="referee-name text-ellipsis">
                        <span class="gray9">批发数量：</span>

                        <span class="blue" v-if="item.min_num&&item.max_num">{{item.min_num}}-{{item.max_num}}</span>
                        <span class="blue" v-if="!item.min_num&&item.max_num">少于{{item.max_num}}</span>
                        <span class="blue" v-if="item.min_num&&!item.max_num">大于{{item.min_num}}</span>
                    </p>
                    
                    <p class="referee-name text-ellipsis">
                        <span class="gray9">价格：</span>
                        <span class="orange">￥{{item.wholesale_price}}</span>
                    </p>
                </div>
              </template>
          </el-table-column>
          <el-table-column prop="stock_num" label="库存"></el-table-column>
          <el-table-column prop="line_price" label="成本"></el-table-column>
          <el-table-column prop="create_time" label="发布时间"></el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

    <Wholesale v-if="is_open_wholesale" :is_open_wholesale="is_open_wholesale" :form="curModel" @closeDialog="closeDialogFunc($event)"></Wholesale>  
  </div>
</template>

<script>
import ProductApi from '@/api/product.js';
import qs from 'qs';
import Wholesale from './part/Wholesale.vue';
export default {
  components: {
      Wholesale
  },
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_name: '',
        category_id: '',
        product_no:''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      /*选中的*/
      multipleSelection: [],
      /*选择的商品列表*/
      select_list:[],
      /*是否显示*/
      dialogVisible: false,
      // 是否加载操作页面
      more_actions:false,
      product_no_search:'',
      is_open_wholesale:false,
      curModel:{}
    };
  },
  created() {
    /*获取列表*/
    this.getData();

  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      ProductApi.skuList(Params, true)
        .then(data => {
          self.loading = false;
          self.categoryList = data.data.category;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开编辑*/
    setWholesale(row){
        this.is_open_wholesale =true;
        this.curModel = row;
    },
    onSubmit(){
      this.curPage = 1;
      this.getData();
    },
    closeDialogFunc(e) {
     

        this.is_open_wholesale = e.openDialog;
        if (e.type == 'success') {
            this.getData();
        }

        
    },

    setOpenWholesale(item){
      let self = this;
      let params = {
        'product_sku_id':item.product_sku_id,
      }
      params.is_open_wholesale = item.is_open_wholesale?1:0;
      params.product_id = item.product_id;
      ProductApi.editSku(params, true)
      .then(data => {
        self.loading = false;
        
        if (data.code == 1) {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          self.getData();
        } else {
          self.loading = false;
        }
      })
      .catch(error => {
        self.loading = false;
      });
    }
    
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/sku/index.vue